import React, { useState, useEffect } from "react";
import InputField from "./../InputField";
import { AnalyzePosition } from "./positionAnalysis";
import { PayOffGraph } from "./payOffGraph";
import { Leg } from "./../../types";
import "./index.css";
import { calculateProfit } from "../../calculations/calculateProfits";
import Switch from "react-switch";

const StrategyBuilder = () => {
  const [symbol, setSymbol] = useState("");
  const [error, setError] = useState("");
  const [leg, setLeg] = useState<Leg>({
    strikePrice: 0,
    price: 0,
    call: true,
    buy: true,
    quantity: 1,
  });
  const [screenSize, setScreenSize] = useState(window.screen.width);
  const [strategy, setStrategy] = useState<Leg[]>([]);
  const [expectedExpiryValue, setExpectedExpiryValue] = useState("");

  const handleSymbolChange = (newSymbol: any) => {
    setSymbol(newSymbol);
  };

  const handleStrikeChange = (newStrike: any) => {
    setLeg({ ...leg, strikePrice: parseFloat(newStrike) });
  };

  const handlePriceChange = (newPrice: any) => {
    setLeg({ ...leg, price: parseFloat(newPrice) });
  };

  const handleQuantityChange = (newQuantity: any) => {
    console.log(newQuantity);
    setLeg({ ...leg, quantity: parseInt(newQuantity) });
  };

  const handleContractChange = (value: any) => {
    setLeg({ ...leg, call: value });
  };

  const handleTradeChange = (value: any) => {
    setLeg({ ...leg, buy: value });
  };

  const expectedExpiryValueChanged = (value: any) => {
    setExpectedExpiryValue(value);
  };

  const addToStrategy = () => {
    const strategyLeg = { ...leg };
    if (strategyLeg.strikePrice && strategyLeg.price) {
      if (!strategyLeg.buy && strategyLeg.quantity > 0) {
        strategyLeg.quantity = -strategyLeg.quantity;
      }
      const existingLeg = strategy.find(
        (value) =>
          value.strikePrice === strategyLeg.strikePrice &&
          value.call === strategyLeg.call
      );
      if (existingLeg) {
        existingLeg.quantity = strategyLeg.quantity;
        existingLeg.price = strategyLeg.price;
      } else {
        strategy.push(strategyLeg);
      }
      setStrategy([...strategy]);
      setError("");
      setLeg({
        ...leg,
        strikePrice: 0,
        price: 0,
      });
    } else {
      setError("Strike Price and Price are mandatory");
    }
  };

  const removeFromStrategy = (index: number) => {
    strategy.splice(index, 1);
    setStrategy([...strategy]);
  };

  const clearStrategy = () => {
    setStrategy([]);
  };

  const pLFields = [
    {
      field: "strikePrice",
      text: "Symbol",
      render: (data: Leg) => {
        return (
          (symbol && symbol + " ") +
          data.strikePrice.toString() +
          (data.call ? " CE" : " PE")
        );
      },
    },
    {
      field: "price",
      text: "Price",
    },
    {
      field: "quantity",
      text: "Qty",
      render: (data: Leg) => {
        return data.quantity;
      },
    },
    {
      field: "",
      text: "P & L",
      render: (data: Leg) => {
        return calculateProfit([data], parseFloat(expectedExpiryValue));
      },
    },
  ];

  const positionFields = [
    {
      field: "strikePrice",
      text: "Symbol",
      render: (data: Leg) => {
        return (
          (symbol && symbol + " ") +
          data.strikePrice.toString() +
          (data.call ? " CE" : " PE")
        );
      },
    },
    {
      field: "price",
      text: "Price",
    },
    {
      field: "quantity",
      text: "Qty",
      render: (data: Leg) => {
        return data.quantity;
      },
    },
    {
      field: "",
      text: "Max Profit",
      render: (data: Leg) => {
        return data.buy
          ? "Unlimited"
          : Math.abs(data.price * data.quantity).toString();
      },
    },
    {
      field: "",
      text: "Max Loss",
      render: (data: Leg) => {
        return !data.buy
          ? "Unlimited"
          : Math.abs(data.price * data.quantity).toString();
      },
    },
  ];

  const optionType = [
    {
      value: "Call",
    },
    {
      value: "Put",
    },
  ];

  const tradeType = [
    {
      value: "Buy",
    },
    {
      value: "Sell",
    },
  ];
  const isSmallScreen = window.screen.width <= 350;
  const getFields = (fields: any[]) => {
    return isSmallScreen
      ? fields.filter((value) => value.field !== "quantity")
      : fields;
  };
  const handleOrientationChange = (event: any) => {
    if ((window as any)["screenRotateTimer"]) {
      clearTimeout((window as any)["screenRotateTimer"]);
    }
    (window as any)["screenRotateTimer"] = setTimeout(() => {
      setScreenSize(window.screen.width);
    }, 300);
  };
  useEffect(() => {
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);
  return (
    <div>
      <InputField
        fieldName="Symbol (optional)"
        placeholder="Index / Stock / Commodity / Forex Symbol"
        value={symbol}
        type="text"
        onValueChange={handleSymbolChange}
      ></InputField>
      <InputField
        fieldName="Strike Price"
        placeholder="Strike price of Call / Put"
        type="number"
        value={leg.strikePrice || ""}
        onValueChange={handleStrikeChange}
      ></InputField>
      <InputField
        fieldName="Price"
        placeholder="Price of Call / Put"
        type="number"
        value={leg.price}
        onValueChange={handlePriceChange}
      ></InputField>
      <InputField
        fieldName="Quantity"
        placeholder="Quantity"
        type="number"
        value={leg.quantity || ""}
        onValueChange={handleQuantityChange}
      ></InputField>

      <div className="e-field" style={{ textAlign: "center", padding: "10px" }}>
        <label>
          <Switch
            className="react-switch"
            onChange={handleContractChange}
            handleDiameter={20}
            width={60}
            checked={leg.call}
            uncheckedIcon={false}
            checkedIcon={false}
            offColor="#C64125"
          />
          <span style={{ padding: "0px 10px" }}>
            {leg.call ? "Call" : "Put"}
          </span>
        </label>
      </div>

      <div className="e-field" style={{ textAlign: "center", padding: "10px" }}>
        <label>
          <Switch
            className="react-switch"
            onChange={handleTradeChange}
            handleDiameter={20}
            width={60}
            checked={leg.buy}
            uncheckedIcon={false}
            checkedIcon={false}
            offColor="#C64125"
          />
          <span style={{ padding: "0px 10px" }}>
            {leg.buy ? "Buy" : "Sell"}
          </span>
        </label>
      </div>

      {error.length > 0 && <div className="e-error">* {error}</div>}

      <div className="e-button" onClick={addToStrategy}>
        Add To Strategy
      </div>

      {strategy.length > 0 && (
        <div>
          <AnalyzePosition
            strategy={strategy}
            lotSize={1}
            positionFields={getFields(positionFields)}
            removeFromStrategy={removeFromStrategy}
            clearStrategy={clearStrategy}
          ></AnalyzePosition>

          <PayOffGraph
            height="100%"
            width="100%"
            strategy={strategy}
            expiryAnalysisProps={{
              strategy,
              positionFields: getFields(pLFields),
              expectedExpiryValue,
              expectedExpiryValueChanged,
            }}
          ></PayOffGraph>
        </div>
      )}
    </div>
  );
};

export default StrategyBuilder;
